
export const SERVICOSTAXAS =
[
    {
        tipoServico: "Alvarás",
        servicos: [
        {
            idServ: "Alvara",
            nomeServ: "Alvará de Construção",
            taxaFixa: false
        },
        {
            idServ: "AlvaraAcresReg",
            nomeServ: "Alvará de Construção com Acréscimo / Reforma e Regularização",
            taxaFixa: false
        },
        {
            idServ: "SubsProj",
            nomeServ: "Substituição de Projeto",
            taxaFixa: false
        },
        {
            idServ: "RenAlvara",
            nomeServ: "Renovação de Alvará",
            taxaFixa: false
        }
        ]
    },
    {
        tipoServico: "Anuências",
        servicos: [
        {
            idServ: "Anuencia",
            nomeServ: "Anuência Prévia",
            taxaFixa: false
        }
        ]
    },
    {
        tipoServico: "Autorizações",
        servicos: [
        {
            idServ: "AutDemol",
            nomeServ: "Autorização de Demolição",
            taxaFixa: false
        },
        {
            idServ: "AutObrasInfra",
            nomeServ: "Autorização de Obras de Infraestrutura",
            taxaFixa: false
        },
        {
            idServ: "AutRepGerais",
            nomeServ: "Autorização de Reparos Gerais",
            taxaFixa: false
        },
        {
            idServ: "AutRepGeraisAcess",
            nomeServ: "Autorização de Reparos Gerais de Acessibilidade",
            taxaFixa: false
        },
        {
            idServ: "AutERB",
            nomeServ: "Autorização para Instalação de ERB",
            taxaFixa: false
        }
        ]
    },
    {
        tipoServico: "Certidões",
        servicos: [
        {
            idServ: "CertLaudoVist",
            nomeServ: "Certidão de Laudo de Vistoria",
            taxaFixa: false
        },
        {
            idServ: "CertDemolComAut",
            nomeServ: "Certidão de Demolição com Autorização",
            taxaFixa: true
        },
        {
            idServ: "CertHabitese",
            nomeServ: "Certidão de Habite-se",
            taxaFixa: false
        },
        {
            idServ: "CertRegul",
            nomeServ: "Certidão de Regularização",
            taxaFixa: false
        },
        {
            idServ: "CertRegulInfra",
            nomeServ: "Certidão de Regularização para obra de Infraestrutura",
            taxaFixa: false
        },
        {
            idServ: "CertRetEndNum",
            nomeServ: "Certidão de Retificação de Endereço e Número",
            taxaFixa: false
        },
        {
            idServ: "CertUsoOcup",
            nomeServ: "Certidão de Uso e Ocupação do Solo",
            taxaFixa: true
        },
        {
            idServ: "CertUsoOcupDir",
            nomeServ: "Certidão de Uso e Ocupação do Solo e Diretrizes",
            taxaFixa: true
        },
        {
            idServ: "RenHabitese",
            nomeServ: "Habite-se fora do prazo",
            taxaFixa: false
        }
        ]
    },
    {
        tipoServico: "Declarações",
        servicos: [
        {
            idServ: "DeclAtendTermoCompr",
            nomeServ: "Declaração de Atendimento a Termo de Compromisso",
            taxaFixa: false
        },
        {
            idServ: "DeclConcInstERBComAut",
            nomeServ: "Declaração de Conclusão de Instalação de ERB com Autorização",
            taxaFixa: false
        },
        {
            idServ: "DeclConcInstERBSemAut",
            nomeServ: "Declaração de Conclusão de Instalação de ERB sem Autorização",
            taxaFixa: false
        },
        {
            idServ: "DeclConcObrasInfra",
            nomeServ: "Declaração de Conclusão de Obras de Infraestrutura",
            taxaFixa: false
        },
        {
            idServ: "DeclConcRepGerais",
            nomeServ: "Declaração de Conclusão de Reparos Gerais",
            taxaFixa: true
        },
        {
            idServ: "DeclConcRepGeraisAcess",
            nomeServ: "Declaração de Conclusão de Reparos Gerais de Acessibilidade",
            taxaFixa: true
        },
        {
            idServ: "DeclGLP",
            nomeServ: "Declaração de GLP",
            taxaFixa: false
        },
        {
            idServ: "DeclNumPorta",
            nomeServ: "Declaração de Número de Porta",
            taxaFixa: false
        }
        ]
    },
    {
        tipoServico: "Fiscalização - emissão de multas",
        servicos: [
        {
            idServ: "AutoDeEmbargo",
            nomeServ: "Prosseguimento de obra embargada",
            taxaFixa: false
        },
        {
            idServ: "AutoDeInfracao",
            nomeServ: "Laudo de vistoria - Auto de Infração",
            taxaFixa: false
        },
        {
            idServ: "ObraIniciadaSemLicenca",
            nomeServ: "Obra Iniciada sem Licença",
            taxaFixa: false
        },
        {
            idServ: "ReparosGeraisSemLicenca",
            nomeServ: "Reparos Gerais Iniciados sem Licença",
            taxaFixa: false
        },
        {
            idServ: "CertDemolSemAut",
            nomeServ: "Certidão de Demolição sem Autorização",
            taxaFixa: false
        }
        ]
    },
    {
        tipoServico: "Termos",
        servicos: [
        {
            idServ: "TermoDemarc",
            nomeServ: "Termo de Demarcação",
            taxaFixa: false
        },
        {
            idServ: "TermoDesm",
            nomeServ: "Termo de Desmembramento",
            taxaFixa: false
        },
        {
            idServ: "TermoRem",
            nomeServ: "Termo de Remembramento",
            taxaFixa: false
        },
        {
            idServ: "TermoDesmRem",
            nomeServ: "Termo de Remembramento / Desmembramento ",
            taxaFixa: false
        },
        {
            idServ: "TermoDesmComIncorporacao",
            nomeServ: "Termo de Desmembramento com Incorporação",
            taxaFixa: false
        },
        {
            idServ: "TermoVerObras",
            nomeServ: "Termo de Verificação de Obras",
            taxaFixa: false
        }
        ]
    }
]

export const semTaxaProtocolo =
[
    "AutoDeEmbargo",
    "AutoDeInfracao",
    "ObraIniciadaSemLicenca",
    "ReparosGeraisSemLicenca",
    "AutObrasInfra",
    "CertDemolComAut",
    "CertUsoOcup",
    "CertUsoOcupDir",
    "DeclConcRepGerais",
    "DeclConcRepGeraisAcess",
    "Protocolo",
    "TermoDemarc"
]

export const comTipoUso = 
[
    "Alvará de Construção",
    "Alvará de Construção com Acréscimo / Reforma e Regularização",
    "Substituição de Projeto",
    "Renovação de Alvará",
    "Anuência Prévia",
    "Autorização de Reparos Gerais",
    "Autorização de Reparos Gerais de Acessibilidade",
    "Certidão de Laudo de Vistoria",
    "Certidão de Regularização",
    "Certidão de Habite-se",
    "Renovação de Habite-se"
]
